import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ResourcesGrid = () => {
  const resources = [
    {
      icon: 'ri-shield-user-line',
      title: 'Patient Portal Access',
      description: 'Securely access your treatment documents, forms, and medical records online.',
      link: '/patient-portal',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Insurance & Rates Information',
      description: 'Learn about accepted insurance plans, payment options, and billing support.',
      link: '/rates',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'QMAP Training Classes',
      description: 'Enroll in Qualified Medication Administration Personnel certification courses.',
      link: '/qmap',
    },
    {
      icon: 'ri-article-line',
      title: 'Mental Health Blog',
      description: 'Read expert articles, clinic news, and resources for patients and families.',
      link: '/blog',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-gray mb-4">
            Resources for Patients & Families
          </h2>
        </motion.div>

        {/* Resources Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {resources.map((resource, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={resource.link}
                className="block bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 h-full cursor-pointer group"
              >
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i className={`${resource.icon} text-4xl text-primary group-hover:text-primary-dark transition-colors`}></i>
                </div>
                <h3 className="text-xl font-bold text-neutral-gray mb-3">
                  {resource.title}
                </h3>
                <p className="text-neutral-gray/70 mb-4 leading-relaxed text-sm">
                  {resource.description}
                </p>
                <span className="inline-flex items-center space-x-2 text-primary group-hover:text-primary-dark font-semibold transition-colors">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourcesGrid;